module.exports = __webpack_public_path__ + "img/unarchive-tree.df3ba84a.svg";